module.exports = __webpack_public_path__ + "static/img/pic_setting_2.6cede189.png";